import { css } from '@microsoft/fast-element';
import { getToken, neutralForegroundRest } from '../../design-tokens';
import { display } from '../../foundation/display';

export const sideBarStyles = css`
    ${display('flex')}

    :host {
        display: flex;
        flex-direction: column;

        box-sizing: border-box;

        background: ${getToken('ui-nav-bar-color-background')};
        color: ${neutralForegroundRest};
    }

    :host(.floating) {
        position: absolute;
        top: 0;
    }

    :host(.left) {
        left: 0;
    }

    :host(.right) {
        right: 0;
    }
`;
